module.exports = __webpack_public_path__ + "img/Portafolio Kuida 6.2eac0f8e.png";